// extracted by mini-css-extract-plugin
export default {"mainContainer":"CookiePolicy_mainContainer__frakX"};